import styled, { css } from 'styled-components';
import { COLOR_GRAY_90, COLOR_PURPLE } from 'styles/variables/colors';

export const Title = styled.h2`
  font-size: 1.125rem;
  margin: 0 0 12px 0;
`;

export const Grid = styled.div`
  display: flex;
`;

export const Nav = styled.nav`
  width: 300px;
  margin-right: 55px;
`;

export const NavTab = styled.a`
  display: block;
  padding: 13px;
  text-decoration: none;
  color: ${COLOR_GRAY_90};
  margin-bottom: 5px;

  ${(props) =>
    props.isActive &&
    css`
      background: rgba(120, 51, 255, 0.09);
      color: ${COLOR_PURPLE};
      border-right: 4px solid ${COLOR_PURPLE};
      margin-bottom: 10px;
    `}
`;

export const PlanSection = styled.div`
  width: 100%;
`;
